import React, { useState, useEffect } from 'react';
import { statsApi } from '../services/api';

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await statsApi.getOverview();
        setStats(response.data);
      } catch (err) {
        setError('Fehler beim Laden der Statistiken');
        console.error('Stats error:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (isLoading) {
    return (
      <div className="dashboard-loading">
        <div className="loading-spinner"></div>
        <p>Lade Statistiken...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-error">
        <p>{error}</p>
      </div>
    );
  }

  const cards = [
    {
      title: 'Benutzer gesamt',
      value: stats?.total_users || 0,
      subtitle: `${stats?.verified_users || 0} verifiziert`,
      icon: '👥',
    },
    {
      title: 'Neue Benutzer (Woche)',
      value: stats?.new_users_week || 0,
      subtitle: `${stats?.new_users_today || 0} heute`,
      icon: '📈',
    },
    {
      title: 'Aktive Benutzer (Woche)',
      value: stats?.active_users_week || 0,
      subtitle: 'Letzte 7 Tage',
      icon: '🟢',
    },
    {
      title: 'Beiträge gesamt',
      value: stats?.total_posts || 0,
      subtitle: `${stats?.total_comments || 0} Kommentare`,
      icon: '📝',
    },
    {
      title: 'Offene Reports',
      value: stats?.pending_reports || 0,
      subtitle: 'Zu bearbeiten',
      icon: '🚨',
      highlight: stats?.pending_reports > 0,
    },
    {
      title: 'Gesperrte Benutzer',
      value: stats?.suspended_users || 0,
      subtitle: 'Aktuell gesperrt',
      icon: '🔒',
    },
  ];

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Statistiken</h1>
        <p className="dashboard-subtitle">Übersicht über die UNIVERSE Plattform</p>
      </div>

      <div className="stats-grid">
        {cards.map((card, index) => (
          <div
            key={index}
            className={`stat-card ${card.highlight ? 'highlight' : ''}`}
          >
            <div className="stat-icon">{card.icon}</div>
            <div className="stat-content">
              <h3 className="stat-title">{card.title}</h3>
              <div className="stat-value">{card.value.toLocaleString()}</div>
              <p className="stat-subtitle">{card.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Dashboard;
